import { getFormValues } from 'redux-form';

import {
    API_CALL,
} from '../constants/actionTypes';

import {
    ME,
    HORSES_LIST,
    HORSES_PUT,
    ENHANCED_HORSE_PHOTOS_DELETE_ALL,
    HORSE_PHOTOS_DELETE_SINGLE,
    SALES_GET,
    SALES_FIND,
    SALES_PUT,
    SALES_PDF_UPLOAD,
    HORSE_PHOTO_UPLOAD,
    SALES_STATS_GET,
    UPDATES_LIST,
    POST_HORSE_UPDATE_ON_SALE,
    DELETE_HORSE_UPDATE_ON_SALE,
    TRIGGER_UNDER_TACK_SHOW_YOUTUBE,
    CHECK_FOR_PP_ON_HORSES,
    CHECK_FOR_ENHANCED_FILES_ON_HORSES,
} from '../constants/apiConstants';

import { selectSale } from '../reducers/salesReducer';

export function getMe() {
    return {
        type: API_CALL,
        endpoint: ME,
        url: '/me/',
    };
}

export function horsesList() {
    return {
        type: API_CALL,
        endpoint: HORSES_LIST,
        url: '/horses/',
        qs(getState) {
            const sale = selectSale(getState());
            return {
                sale: sale.id,
            };
        },
    };
}

export function enhancedHorsePhotosDeleteAll() {
    return {
        type: API_CALL,
        endpoint: ENHANCED_HORSE_PHOTOS_DELETE_ALL,
        method: 'DELETE',
        url: '/horse-photos/enhanced/remove-all/',
    };
}

export function horsePhotosDeleteSingle(id, saleType) {
    return {
        type: API_CALL,
        endpoint: HORSE_PHOTOS_DELETE_SINGLE,
        method: 'DELETE',
        url: `/horse-photos/${saleType}/remove-single/${id}/`,
    };
}

export function salesGet(sale_id) {
    return {
        type: API_CALL,
        endpoint: SALES_GET,
        url: `/sales/${sale_id}`,
    };
}

export function salesStatsGet(sale_id) {
    return {
        type: API_CALL,
        endpoint: SALES_STATS_GET,
        url: `/sales/${sale_id}/stats/`,
    };
}

export function salesFind(sale_identifier) {
    return {
        type: API_CALL,
        endpoint: SALES_FIND,
        url: '/sales/',
        qs: {
            sale_identifier,
        },
    };
}

export function salesPut(form) {
    return {
        type: API_CALL,
        endpoint: SALES_PUT,
        method: 'PUT',
        url(getState) {
            const sale = selectSale(getState());
            return `/sales/${sale.id}/`;
        },
        body(getState) {
            const formData = getFormValues(form)(getState());
            const sale = selectSale(getState());
            return {
                ...sale,
                ...formData,
            };
        },
    };
}

export function horsesPut(horse, form) {
    return {
        type: API_CALL,
        endpoint: HORSES_PUT,
        method: 'PUT',
        url() {
            return `/horses/${horse.id}/`;
        },
        body(getState) {
            const formData = getFormValues(form)(getState());
            return {
                ...horse,
                ...formData,
            };
        },
    };
}

export function updatesList() {
    return {
        type: API_CALL,
        endpoint: UPDATES_LIST,
        url: '/updates/',
        qs(getState) {
            const sale = selectSale(getState());
            return {
                'horse__sale_id': sale.id,
            };
        },
    };
}

export function postHorseUpdateOnSale(form) {
    return {
        type: API_CALL,
        endpoint: POST_HORSE_UPDATE_ON_SALE,
        method: 'POST',
        url: '/updates/',
        body(getState) {
            const formData = getFormValues(form)(getState());
            return {
                ...formData,
            };
        },
    };
}

export function deleteHorseUpdateOnSale(form) {
    return {
        type: API_CALL,
        endpoint: DELETE_HORSE_UPDATE_ON_SALE,
        method: 'DELETE',
        url: '/updates/',
        body(getState) {
            const formData = getFormValues(form)(getState());
            return {
                ...formData,
            };
        },
    };
}

export function salesPDFUpload(files) {
    return {
        type: API_CALL,
        endpoint: SALES_PDF_UPLOAD,
        url(getState) {
            const sale = selectSale(getState());
            return `/sales/${sale.id}/upload/`;
        },
        method: 'PUT',
        body() {
            const fd = new FormData();
            fd.append('pdf', files[0]);
            return fd;
        },
    };
}

export function horsePhotoUpload(files, horse, photoType) {
    return {
        type: API_CALL,
        endpoint: HORSE_PHOTO_UPLOAD,
        url(getState) {
            const sale = selectSale(getState());
            return `/horse-photos/${photoType}/${sale.id}/upload/`;
        },
        method: 'POST',
        body() {
            const fd = new FormData();
            fd.append('media', files[0]);
            if (horse) {
                fd.append('horse_hip', horse.hip);
            }
            return fd;
        },
    };
}

export function triggerUnderTackShowYoutube(form) {
    return {
        type: API_CALL,
        endpoint: TRIGGER_UNDER_TACK_SHOW_YOUTUBE,
        url: '/horses/showcase_youtube/',
        body(getState) {
            const sale = selectSale(getState());
            const formData = getFormValues(form)(getState());
            return {
                ...sale,
                ...formData,
            };
        },
        method: 'POST',
    };
}

export function checkForPP() {
    return {
        type: API_CALL,
        endpoint: CHECK_FOR_PP_ON_HORSES,
        url: '/horses/pp_enable/',
        body(getState) {
            const sale = selectSale(getState());
            return {
                ...sale,
            };
        },
        method: 'POST',
    };
}

export function checkForEhancedFiles() {
    return {
        type: API_CALL,
        endpoint: CHECK_FOR_ENHANCED_FILES_ON_HORSES,
        url: '/horses/enhanced_files_enable/',
        body(getState) {
            const sale = selectSale(getState());
            return {
                ...sale,
            };
        },
        method: 'POST',
    };
}
